import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/Paginate';
import { formatNTD } from '../../utils/pricing';
import { toast } from 'react-toastify';
import { useGetProductsQuery, useCreateProductMutation, useDeleteProductMutation } from '../../slices/productsApiSlice';

const ProductListScreen = () => {
  const { pageNumber } = useParams();

  const { data, isLoading, error, refetch } = useGetProductsQuery({ pageNumber});

  const [createProduct, { isLoading: loadingCreate }] = useCreateProductMutation();

  const [deleteProduct, { isLoading: loadingDelete }] = useDeleteProductMutation();

  const deleteHandler = async (id) => {
    if (window.confirm("確定要刪除嗎？")) {
      try {
        await deleteProduct(id);
        toast.success("商品已刪除");
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error)
      }
    }
  }

  const createProductHandler = async () => {
    if (window.confirm("確定要新增一項商品嗎？")) {
      try {
        await createProduct();
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  }

  return <>
    <Row className="align-items-center">
      <Col>
        <h1>商品管理</h1>
      </Col>
      <Col className="text-end">
        <Button variant="success" className="btn-sm my-3" onClick={ createProductHandler }>
          <FaEdit/> 新增商品
        </Button>
      </Col>
    </Row>

    {loadingCreate && <Loader />}
    {loadingDelete && <Loader />}

    {isLoading ? <Loader /> : error ? <Message variant="danger">{error.data.message}</Message> : (
      <>
        <Table striped hover responsive className="table-sm">
          <thead>
            <tr>
              <th>商品編號</th>
              <th>名稱</th>
              <th>價格</th>
              <th>分類</th>
              <th>品牌</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.products.map((product) => 
              (<tr key={product._id}>
                <td>{product._id}</td>
                <td>{product.name}</td>
                <td>{formatNTD(product.price)}</td>
                <td>{product.category}</td>
                <td>{product.brand}</td>
                <td>
                  <LinkContainer to={`/admin/product/${product._id}/edit`}>
                    <Button variant="success" className="btn-sm mx-2" aria-label="編輯商品" title="編輯商品">
                      <FaEdit />
                    </Button>
                  </LinkContainer>
                  <Button variant="danger" className="btn-sm mx-2" aria-label="刪除商品" title="刪除商品" onClick={ () => deleteHandler(product._id)} >
                    <FaTrash style={{color: "white"}} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Paginate pages={data.pages} page={data.page} isAdmin={true} />
      </>
    )}
  </>;
};
export default ProductListScreen;